class EnvService {
	public CALLER: string | undefined;
	public CALLER_PASSWORD: string | undefined;
	public CALLEE: string | undefined;
	public WAC_URI: string | undefined;
	public REALM: string | undefined;
	public CLIENT_ID: string | undefined;
	public HAS_LOGO: boolean;
	public HAS_VIDEO: boolean;
	public HAS_MUTE_AUDIO: boolean;

	constructor() {
		this.CALLER = process.env.REACT_APP_CALLER;
		this.CALLER_PASSWORD = process.env.REACT_APP_CALLER_PASSWORD;
		this.CALLEE = process.env.REACT_APP_CALLEE;
		this.WAC_URI = process.env.REACT_APP_WAC_URI;
		this.REALM = process.env.REACT_APP_REALM;
		this.CLIENT_ID = process.env.REACT_APP_CALLER;
		const hasLogo = process.env.REACT_APP_LOGO === undefined ||
			process.env.REACT_APP_LOGO === 'true';
		this.HAS_LOGO = hasLogo;
		const hasVideo = process.env.REACT_APP_VIDEO === undefined ||
			process.env.REACT_APP_VIDEO === 'true';
		this.HAS_VIDEO = hasVideo;
		const hasMuteAudio = process.env.REACT_APP_MUTE_AUDIO === undefined ||
			process.env.REACT_APP_MUTE_AUDIO === 'true';
		this.HAS_MUTE_AUDIO = hasMuteAudio;
	}
}
const envService = new EnvService();
export default envService;
